import { render } from "./FormSwitch.vue?vue&type=template&id=bca24c56"
import script from "./FormSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSwitch.vue?vue&type=script&setup=true&lang=js"

import "./FormSwitch.vue?vue&type=style&index=0&id=bca24c56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/FormSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bca24c56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bca24c56', __exports__)) {
    api.reload('bca24c56', __exports__)
  }
  
  module.hot.accept("./FormSwitch.vue?vue&type=template&id=bca24c56", () => {
    api.rerender('bca24c56', render)
  })

}


export default __exports__